<template>
  <v-layout row wrap mb-5>
    <v-flex xs12 class="text-xs-center pages-title"><h1>{{ $t('pages.gifts') }}</h1></v-flex>

    <v-progress-circular :size="50" indeterminate color="primary" v-if="giftsLoading"></v-progress-circular>
    <div class="ui-width-1-3@l ui-width-1-2@m ui-container">
      <div class="ui-grid ui-cols-2@s ui-cols-3@l ui-gap">
        <div class="ui-width-1-2@m ui-width-1-3@l"  v-for="item in items" :key="item.place">
          <v-card class="pm-gift">
            <v-card-title><span>{{ item.place }}</span> &nbsp;<div>{{ $t('gift.place') }}</div>
            </v-card-title>
            <v-card-media :src="item.image" height="200px" contain></v-card-media>
            <v-card-text>
              {{ item.title[$i18n.locale] }}
              <v-subheader class="justify-center">
                {{ item.subtitle[$i18n.locale] || '&nbsp;' }}
              </v-subheader>
            </v-card-text>
            <a :href="item.url[$i18n.locale]" target="_blank" v-if="item.url" class="stretched-link"></a>
          </v-card>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import PagesFunc from '@/components/pages'

export default {
  name: 'Gifts',
  data () {
    return {
      giftsLoading: false,
      items: [
        {
          place: 1,
          image: '/static/images/gifts/1.png',
          title: {
            ro: `Televizor Hisense 65E7HQ`,
            ru: `Телевизор Hisense 65E7HQ`
          },
          subtitle: {
            ro: `65"/ QLED/ 4K/ Smart TV/ Black`,
            ru: `65"/ QLED/ 4K/ Smart TV/ Черный`
          },
          url: {
            ro: 'https://enter.online/televizoare/hisense-65e7hq-65-qled-4k-smart-tv-black',
            ru: 'https://enter.online/ru/televizory/hisense-65e7hq-65-qled-4k-smart-tv-cernyi'
          }
        },
        {
          place: 2,
          image: '/static/images/gifts/2.png',
          title: {
            ro: `Televizor Hisense 55E7HQ`,
            ru: `Телевизор Hisense 55E7HQ`
          },
          subtitle: {
            ro: `55"/ QLED/ 4K/ Smart TV/ Black`,
            ru: `55"/ QLED/ 4K/ Smart TV/ Черный`
          },
          url: {
            ro: 'https://enter.online/televizoare/hisense-55e7hq-55-qled-4k-smart-tv-black',
            ru: 'https://enter.online/ru/televizory/hisense-55e7hq-55-qled-4k-smart-tv-cernyi'
          }
        },
        {
          place: 3,
          image: '/static/images/gifts/3.png',
          title: {
            ro: `Televizor Hisense 50E7HQ`,
            ru: `Телевизор Hisense 50E7HQ`
          },
          subtitle: {
            ro: `50"/ QLED/ 4K/ Smart TV/ Black`,
            ru: `50"/ QLED/ 4K/ Smart TV/ Черный`
          },
          url: {
            ro: 'https://enter.online/televizoare/hisense-50e7hq-50-qled-4k-smart-tv-black',
            ru: 'https://enter.online/ru/televizory/hisense-50e7hq-50-qled-4k-smart-tv-cernyi'
          }
        },
        {
          place: 4,
          image: '/static/images/gifts/4.png',
          title: {
            ro: `Microsoft Xbox Series S`,
            ru: `Microsoft Xbox Series S`
          },
          subtitle: {
            ro: `512 GB/ White`,
            ru: `512 ГБ/ Белый`
          },
          url: {
            ro: 'https://enter.online/for-gamers/console/microsoft-xbox-series-s-512-gb-white-86916',
            ru: 'https://enter.online/ru/dlya-geymerov/igrovyye-konsoli/microsoft-xbox-series-s-512-gb-belyi'
          }
        },
        {
          place: 5,
          image: '/static/images/gifts/5.png',
          title: {
            ro: `Cafetieră Gorenje ESCM15DBK`,
            ru: `Кофеварка Gorenje ESCM15DBK`
          },
          subtitle: {
            ro: `Manual (cu cupă)/ 1.5 l/ Inox`,
            ru: `Рожковая/ 1.5 л/ Нержавеющая сталь`
          },
          url: {
            ro: 'https://enter.online/preparare-bauturi/aparate-de-cafea/gorenje-escm15dbk-manual-cu-cupa-15-l-inox',
            ru: 'https://enter.online/ru/prigotovlenie-napitkov/kofemashiny/gorenje-escm15dbk-rozkovaya-15-l-nerzaveyushhaya-stal'
          }
        },
        {
          place: '6-7',
          image: '/static/images/gifts/6.png',
          title: {
            ro: `Grill electric Gorenje KR1800EPRO`,
            ru: `Электрогриль Gorenje KR1800EPRO`
          },
          subtitle: {
            ro: `Închis (cu două părți)/ 1800 W/ Black`,
            ru: `Закрытый (двухсторонний)/ 1800 Вт/ Черный`
          },
          url: {
            ro: 'https://enter.online/preparare-termica/gratare-electrice/grill-electric-gorenje-kr1800epro-closed-double-sided-1800-w-black',
            ru: 'https://enter.online/ru/prigotovlenie-pishi/electrogrily/gril-gorenje-kr1800epro-closed-double-sided-1800-w-chernyy'
          }
        },
        {
          place: '8-10',
          image: '/static/images/gifts/8.png',
          title: {
            ro: `Umidificator de aer Gorenje H45W`,
            ru: `Увлажнитель воздуха Gorenje H45W`
          },
          subtitle: {
            ro: `Cu ultrasunet/ White`,
            ru: `Ультразвуковой/ Белый`
          },
          url: {
            ro: 'https://enter.online/climatizare/umidificatoare-de-aer/gorenje-h45w-ultrasunet-white',
            ru: 'https://enter.online/ru/klimaticheskaja-tehnika/uvlajniteli-vozduha/gorenje-h45w-ultrazvuk-belyy'
          }
        },
        {
          place: '11-15',
          image: '/static/images/gifts/11.png',
          title: {
            ro: `Aspirator portabil Gorenje MVC72FW`,
            ru: `Портативный пылесос Gorenje MVC72FW`
          },
          subtitle: {
            ro: `55 W/ Gray White`,
            ru: `55 Вт/ Серый Белый`
          },
          url: {
            ro: 'https://enter.online/aspiratoare/aspirator-gorenje-mvc72fw-de-mana-55-w-white',
            ru: 'https://enter.online/ru/pylesosy/pylesos-gorenje-mvc72fw-de-mana-55-w-belyy'
          }
        },
        {
          place: '16-20',
          image: '/static/images/gifts/16.png',
          title: {
            ro: 'Rucsac pentru laptop RivaCase 7760',
            ru: 'Рюкзак для ноутбука RivaCase 7760'
          },
          subtitle: {
            ro: `15.6"/ Black`,
            ru: `15.6"/ Черный`
          },
          url: {
            ro: 'https://enter.online/rucsacuri/rucsac-rivacase-7760-15-6-black',
            ru: 'https://enter.online/ru/ryukzaki/ryukzak-rivacase-7760-15-6-chernyy'
          }
        }
      ]
    }
  },
  created () {
    PagesFunc.breadcrumbsJSON(this.$router.currentRoute.path, this.$t('pages.gifts'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Gifts.vue